export default __webpack_public_path__ + "media/images/fancybox/fancybox-b7fc0c1f091296838dc2338e19634379.png";